/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentTypeEnum {
  PAYTURE = "payture",
  TINKOV = "tinkov",
  CLOUDPAYMENTS = "cloudpayments",
}
